import QuotationAmounts from './QuotationAmounts';

const CLIENT_CHARGED_SERVICE_TYPE = 1;
const CLOSED_VIEW_STATUS = 107;
const ACCEPTED_VALUES = [1, '1', true];

const getAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

const getQuotationKey = (quotationItem, index) => {
  if (quotationItem.quotation_id != null) {
    return `quotation:${quotationItem.quotation_id}`;
  }

  if (quotationItem.order_activity_id != null) {
    return `activity:${quotationItem.order_activity_id}`;
  }

  return `item:${index}`;
};

class AdditionalQuotationAmounts extends QuotationAmounts {
  fromFrozenQuotationItems(quotationItems) {
    const items = Array.isArray(quotationItems) ? quotationItems : [];
    const quotations = new Map();

    items.forEach((quotationItem, index) => {
      const isAccepted = ACCEPTED_VALUES.includes(quotationItem.accepted);
      const isClientCharged = Number(quotationItem.activity_service_type)
        === CLIENT_CHARGED_SERVICE_TYPE;
      const isOpen = Number(quotationItem.view_status) !== CLOSED_VIEW_STATUS;

      if (isAccepted && isClientCharged && isOpen) {
        const quotationKey = getQuotationKey(quotationItem, index);
        if (!quotations.has(quotationKey)) quotations.set(quotationKey, quotationItem);
      }
    });

    const { taxes, subtotal, total } = Array.from(quotations.values()).reduce(
      (totals, quotation) => ({
        taxes: totals.taxes + getAmount(quotation.taxesAmount),
        subtotal: totals.subtotal + getAmount(quotation.subtotal),
        total: totals.total + getAmount(quotation.amount),
      }),
      { taxes: 0, subtotal: 0, total: 0 },
    );

    this.taxes = taxes.toFixed(2);
    this.subtotal = subtotal.toFixed(2);
    this.total = total.toFixed(2);

    return this;
  }
}

export default AdditionalQuotationAmounts;
